import { render, staticRenderFns } from "./newPostPreviewFooter.vue?vue&type=template&id=54ef73b7"
import script from "./newPostPreviewFooter.vue?vue&type=script&lang=js"
export * from "./newPostPreviewFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports